import { ModalType } from '../../../types/modals';
import { ModalType as SharedModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

import GroupCloseModal from './GroupCloseModal';
import GroupChangeFounderModal from './GroupChangeFounderModal';

import InviteToGroupModal from './InviteToGroupModal';
import ReportProfileModal from '../ReportProfile/ReportProfileModal';
import AccountReactivatedModal from './AccountReactivatedModal';
import OriginalDeviationPopup from '@wix/da-submit-shared/pkg/modals/OriginalDeviationPopup';
import { Suspense } from 'react';
import SubmitSharedReduxLoadable from '@wix/da-submit-shared/pkg/redux/ModuleLoadable';

export const modalRenderer = (modalType: string, requestClose: () => void, params?: any) => {
  switch (modalType) {
    case ModalType.REPORT_PROFILE:
      return <ReportProfileModal requestClose={requestClose} userId={params.userId} />;

    case ModalType.GROUP_CLOSE:
      return <GroupCloseModal requestClose={requestClose} />;

    case ModalType.GROUP_CHANGE_FOUNDER:
      return <GroupChangeFounderModal requestClose={requestClose} />;

    case ModalType.INVITE_TO_GROUP:
      return <InviteToGroupModal requestClose={requestClose} group={params.group} />;

    case ModalType.ACCOUNT_REACTIVATED:
      return <AccountReactivatedModal requestClose={requestClose} />;

    case SharedModalType.ORIGINAL_DEVIATION:
      return (
        <Suspense fallback={null}>
          <SubmitSharedReduxLoadable />
          <OriginalDeviationPopup onRequestClose={requestClose} {...params} />
        </Suspense>
      );
    default:
      return;
  }
};

export default modalRenderer;
